import { v4 as uuidv4 } from 'uuid'

export const notYetImplementedWithError = (): void => { throw new Error('Not yet implemented') }

export const notYetImplemented = (): void => { console.warn('Not yet implemented') }

export const uuid = (): string => {
  return uuidv4()
}

export async function downloadFile (url: string): Promise<File> {
  const res = await fetch(url);
  const blob = await res.blob();

  const mime = blob.type;
  const ext = mime.slice(mime.lastIndexOf('/') + 1, mime.length);

  const file = new File([blob], `filename.${ext}`, {
    type: mime
  })

  return file
}
